import { environment } from 'src/environments/environment';

/** Bump when logo image files change — busts browser/CDN cache on ?v= query. */
export const LOGO_CACHE_VERSION = environment.logoVersion || '20260613';

function asset(path: string): string {
  return `${path}?v=${LOGO_CACHE_VERSION}`;
}

export const BRAND_ASSETS = {
  logo: asset('/assets/img/logo.png'),
  smallLogo: asset('/assets/img/smalllogo.png'),
  mailLogo: asset('/assets/img/maillogo.png'),
  favicon: asset('/assets/img/favico.png'),
};
